/** The states a handover moves through (the server's `CashHandoverStatus`). */
export const CASH_HANDOVER_STATUSES = ['RECORDED', 'CONFIRMED', 'REJECTED'];
export class CashHandoverApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Record cash a courier handed over (the maker, `payout:create`). Capped at the debt the ledger shows. */
    record(input) {
        // D450: the reference is always sent — a blank one is the server's `HANDOVER_REFERENCE_REQUIRED` to explain.
        const body = { courierId: input.courierId, amountMinor: input.amountMinor, reference: input.reference };
        return this.client.request({ method: 'POST', path: '/v1/cash-handovers', body, auth: true });
    }
    /**
     * D450: the couriers of `market` holding the platform's cash now (`payout:view`), largest debt first — the desk's
     * starting list. A failed read is an error (`MARKET_REQUIRED`, `PAYOUT_CURRENCY_REQUIRED`, `HOLDERS_SOURCE_UNAVAILABLE`),
     * never an empty list.
     */
    couriersHoldingCash(market) {
        return this.client.request({ method: 'GET', path: `/v1/cash-handovers/couriers?market=${encodeURIComponent(market)}`, auth: true });
    }
    /** The per-market queue (`payout:view`), oldest first; RECORDED unless a status is named. */
    queue(query) {
        const params = new URLSearchParams();
        params.set('market', query.market);
        if (query.status !== undefined)
            params.set('status', query.status);
        if (query.limit !== undefined)
            params.set('limit', String(query.limit));
        return this.client.request({ method: 'GET', path: `/v1/cash-handovers?${params.toString()}`, auth: true });
    }
    /**
     * Confirm (which posts) or reject (which moves no money) a RECORDED handover, with a reason (`payout:settle`). The
     * checker is the session; the maker's confirmation is refused `SELF_APPROVAL`, the courier's `SELF_HANDOVER`.
     */
    decide(handoverId, input) {
        return this.client.request({
            method: 'POST',
            path: `/v1/cash-handovers/${encodeURIComponent(handoverId)}/decision`,
            body: { decision: input.decision, reason: input.reason, market: input.market },
            auth: true,
        });
    }
    /**
     * D438 (finding A-02): the market's debtor portfolio — every driver owing commission (the payout ledger's receivable
     * over payable), largest first, aged FIFO in buckets (`payout:view`). Fails closed: `MARKET_REQUIRED`,
     * `PAYOUT_CURRENCY_REQUIRED`, `503 DEBTS_SOURCE_UNAVAILABLE` — never an empty list that reads as "nobody owes".
     */
    driverDebts(market) {
        return this.client.request({ method: 'GET', path: `/v1/finance/driver-debts?market=${encodeURIComponent(market)}`, auth: true });
    }
}
//# sourceMappingURL=cash-handovers.js.map